import { render, staticRenderFns } from "./picker-dropdown.vue?vue&type=template&id=06601625&"
import script from "./picker-dropdown.vue?vue&type=script&lang=js&"
export * from "./picker-dropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06601625')) {
      api.createRecord('06601625', component.options)
    } else {
      api.reload('06601625', component.options)
    }
    module.hot.accept("./picker-dropdown.vue?vue&type=template&id=06601625&", function () {
      api.rerender('06601625', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/color-picker/src/components/picker-dropdown.vue"
export default component.exports